import axios from "axios";

// export const FILE_API_ENDPOINT = "https://dev.iggietech.in/outletacemain/";
// export const FILE_API_ENDPOINT = "http://192.168.29.3:3033/hms";
// export const FILE_API_ENDPOINT = "https://oracle.iggietech.in/hrms/"
export const FILE_API_ENDPOINT = "https://aaladi.inzpire.in/hrms/";
// export const FILE_API_ENDPOINT = "https://oracle.iggietech.in/hms/";
// export const FILE_API_ENDPOINT = "https://mathiroerp.inzpire.in/hms/";
// export const FILE_API_ENDPOINT = "https://oracle.iggietech.in/financials/"


export const API_ENDPOINT = `${FILE_API_ENDPOINT}`;

export const getAxiosInstance = () => {
    var axiosInstance = axios.create({
        timeout: 1000 * 60
    });
    axiosInstance.defaults.baseURL = API_ENDPOINT;
    return axiosInstance;
};

var axiosInstance = getAxiosInstance();
axiosInstance.interceptors.request.use(
    function (config) {
        console.log(config.url);
        if (config.url === "users/login") {
            return config;
        } else {
            let authToken = window.localStorage.getItem("outletace_jwt");
            console.log("Checking", authToken);
            console.log(authToken);
            config.headers["Authorization"] = `Bearer ${authToken}`;
        }
        return config;
    },
    function (error) {
        console.log(error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = window.localStorage.getItem("outletace_refresh_token");


        }

        return Promise.reject(error);
    }
);

export const fetchLogin = (username, password) => {
    return axiosInstance.post(
        "users/login",
        {
            username: username,
            password: password
        },
        {}
    );
};
export const getReportData = (details) => {
    return axiosInstance.post(`frappe/api/method/frappe.desk.reportview.get`, details, {});
};
export const getUserCompany = (username) => {
    return axiosInstance.get(`frappe/api/resource/User Permission?fields=["user", "allow", "for_value"]&filters=[["allow", "=", "Company"], ["user","=", "${username}"]]`);
}
export const getLoggedInUser = () => {
    return axiosInstance.get(`frappe/api/method/frappe.auth.get_logged_user`);
}
export const searchLink = (details) => {
    return axiosInstance.post(`frappe/api/method/frappe.desk.search.search_link`, details);
}
// API service HRMS
export const Employeedetails = (queryParams) => {
    return axiosInstance.get(`/frappe/api/method/frappe.desk.reportview.get?${queryParams}`);
}
export const createEmployee = (payload) => {
    return axiosInstance.post('/frappe/api/method/frappe.desk.form.save.savedocs', payload);
};
export const saveDoc = (payload) => {
    return axiosInstance.post('/frappe/api/method/frappe.desk.form.save.savedocs', payload);
};
export const getEmployeeDetails = (employeeId) => {
    return axiosInstance.get(`/frappe/api/method/frappe.desk.form.load.getdoc?doctype=Employee&name=${employeeId}`
    );
};
export const updateEmployee = (name, payload) => {
    return axiosInstance.put(`/frappe/api/resource/Employee/${name}`, payload);
};

export const runReportData = (details) => {
    return axiosInstance.post("bypass/api/method/frappe.desk.query_report.run", details);
}



export const getMaxFileSize = () => {
    return axiosInstance.get(`/frappe/api/method/frappe.core.api.file.get_max_file_size`);
};

export const uploadEmployeeFile = (file, employeeId) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("is_private", "1");
    formData.append("doctype", "Employee");
    formData.append("docname", employeeId); // Use the actual employee ID
    formData.append("fieldname", "image");
    formData.append("folder", "Home");

    return axiosInstance.post(
        `frappe/api/method/upload_file`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const updateFileAttachment = ({ fileName, attached_to_doctype, attached_to_name }) => {
    return axiosInstance.put(
        `frappe/api/resource/File/${encodeURIComponent(fileName)}`,
        {
            attached_to_doctype,
            attached_to_name
        }
    );
};
export const getEmployeeProfilePhoto = (employeeId) => {
    return axiosInstance.get(
        `frappe/api/resource/File`,
        {
            params: {
                fields: JSON.stringify(["name", "file_name", "file_url", "is_private", "creation"]),
                filters: JSON.stringify([
                    ["attached_to_doctype", "=", "Employee"],
                    ["attached_to_name", "=", employeeId],
                    ["is_private", "=", 1],  // Profile photos are typically private
                    ["file_name", "like", "%profile%"]  // Assuming profile photos have 'profile' in filename
                ]),
                limit: 1  // We only expect one profile photo per employee
            }
        }
    );
};

export const uploadEmployeeDocument = (file, employeeId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('is_private', '1');
    formData.append('doctype', 'Employee');
    formData.append('docname', employeeId);
    formData.append('folder', 'Home/Attachments');

    return axiosInstance.post(
        'frappe/api/method/upload_file',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};
export const getEmployeeAttachments = (employeeId) => {
    return axiosInstance.get(
        `frappe/api/resource/File`,
        {
            params: {
                fields: JSON.stringify(["name", "file_name", "file_url", "is_private", "creation"]),
                filters: JSON.stringify([
                    ["attached_to_doctype", "=", "Employee"],
                    ["attached_to_name", "=", employeeId]
                ])
            }
        }
    );
};
export const retrievefile = (url) => {
    return axiosInstance.get(`frappe/${url}`, { responseType: 'blob' });
}

export const saveEmployeeProfileImage = (docData) => {
    return axiosInstance.post('/frappe/api/method/frappe.desk.form.save.savedocs', {
        doc: JSON.stringify(docData),
        action: "Save"
    });
};
export const getEmployeeAdvancesbranchwise = (payload) => {
    return axiosInstance.post(`frappe/api/method/frappe.desk.query_report.run`, payload
    );
};

export const getDevices = (params) => {
    return axiosInstance.get(`/Devices`);
};

export const updateAttendance = (id, details) => {
    return axiosInstance.put(`frappe/api/resource/Attendance/${id}`, details);
};

export const getBranches = (params) => {
    return axiosInstance.get(`frappe/api/resource/Branch${params ? `?${params}` : ``}`);
};

export const submitAttendance = (params) => {
    return axiosInstance.get(`/Devices/submitAttendance${params ? `?${params}` : ``}`);
};

export const markAttendance = (params) => {
    return axiosInstance.get(`/Devices/markattendance${params ? `?${params}` : ``}`);
}